import React from 'react';
import { motion } from 'framer-motion';

export default function TransitionSwoop({ isVisible, onComplete }) {
  if (!isVisible) return null;

  const colors = ['#FF5DA2', '#6E53FF', '#00E5FF'];

  return (
    <div className="fixed inset-0 z-[100] pointer-events-none flex flex-col">
      {colors.map((color, i) => (
        <motion.div
          key={i}
          className="absolute inset-0 w-full h-full"
          style={{ backgroundColor: color, zIndex: 100 + i }}
          initial={{ x: '100%' }}
          animate={{ x: ['100%', '0%', '-100%'] }}
          transition={{
            duration: 1.2,
            ease: [0.22, 1, 0.36, 1],
            delay: i * 0.1,
            times: [0, 0.4, 1]
          }}
          onAnimationComplete={() => {
            if (i === colors.length - 1 && onComplete) {
              onComplete();
            }
          }}
        />
      ))}
    </div>
  );
}
